<template>
  <VDialogV3
    title="Вернуть потребность"
    :loading="false"
    @close="closeDialog"
  >
    <section>
      <VButtonGroup>
        <VButton
          :theme="getStageButtonTheme(true)"
          @click="isToSelectOptions = true"
        >
          К поиску вариантов
        </VButton>
        <VButton
          :disabled="localDemandV2.options.length === 0 || localDemandV2.isWaitingForChoose"
          :theme="getStageButtonTheme(false)"
          @click="isToSelectOptions = false"
        >
          К выбору вариантов
        </VButton>
      </VButtonGroup>

      <VTextarea
        ref="reasonTextInput"
        v-model="reasonText"
        placeholder="Укажите причину переноса потребности"
      />
    </section>

    <template #footer>
      <VButton
        theme="primary"
        @click="move(localDemandV2, reasonText)"
      >
        Отправить
      </VButton>
      <VButton @click="closeDialog">
        Отменить
      </VButton>
    </template>
  </VDialogV3>
</template>

<script lang="ts">

import DemandV2         from '@/domains/DemandsV2/DemandV2';
import DemandsV2Service from '@/domains/DemandsV2/DemandsV2Service';

export default defineComponent({
  name: 'MoveDemandV2',

  props: {
    localDemandV2: {
      type:    DemandV2,
      default: null,
    },
  },

  emits: [
    DemandV2.Events.Created,
    DemandV2.Events.Updated,
    DemandV2.Events.Deleted,
  ],

  data() {
    return {

      /** select - подбор
       *   choose - выбор
       * */

      isToSelectOptions: true,
      reasonText:        null as string | null,
    };
  },

  methods: {
    /** Активная кнопка выбора стадии подсвечена, вторая нейтральна. */
    getStageButtonTheme(isSelectOptionsButton: boolean): string {
      if (this.isToSelectOptions === isSelectOptionsButton) {
        return 'primary';
      }
      else {
        return 'default';
      }
    },

    async sendToEnrichOptionsStage(demandV2: DemandV2, reasonText: string | null): Promise<void> {
      demandV2.moveToEnrichOptionsStage();

      const isSuccess =  await DemandsV2Service.update(demandV2, reasonText)

      if (isSuccess === true) {
        this.$emit(DemandV2.Events.Updated);

        this.$core.showNotification.success('Потребность возвращена к подбору вариантов');
        this.$core.dialogs.MoveDemandV2.resolve();
      }
    },

    async sendToChooseOptionsStage(demandV2: DemandV2, reasonText: string | null): Promise<void> {
      demandV2.moveToChooseOptionsStage();

      const isSuccess = await DemandsV2Service.update(demandV2, reasonText);

      if (isSuccess === true) {
        this.$emit(DemandV2.Events.Updated);

        this.$core.showNotification.success('Потребность возвращена к выбору вариантов');
        this.$core.dialogs.MoveDemandV2.resolve();
      }

    },

    async move(localDemandV2: DemandV2, reasonText: string | null): Promise<void> {
      const demandV2 = await DemandsV2Service.get(localDemandV2.id)

      if (this.isToSelectOptions) {
        await this.sendToEnrichOptionsStage(demandV2, reasonText)
      } else {
        await this.sendToChooseOptionsStage(demandV2, reasonText)
      }
    },

    closeDialog(): void {
      this.$core.dialogs.MoveDemandV2.hide();
    },
  },
});
</script>